module.exports = __webpack_public_path__ + "img/pubgm-bg.3a08a41.png";